import { useFeatureIsOn } from '@growthbook/growthbook-react';

import { FEATURE_FLAG_KEYS } from '../../config/growthbook';
import { useAuth } from './useAuth';
import { ZURICH_CARRIER_PREFIX } from './useIsZurichCarrier';

export const useIsCarrierSubmissionsEnabled = () => {
  const { carrierPrefix } = useAuth();
  return (
    useFeatureIsOn(FEATURE_FLAG_KEYS.CARRIER_SUBMISSIONS) &&
    carrierPrefix === ZURICH_CARRIER_PREFIX
  );
};
